import { render } from "./Card.vue?vue&type=template&id=2da15c7a"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=2da15c7a&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\landing-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__